/**
 * Renders the CodatLink component
 *
 * @param {HTMLElement} target The HTML Element to which CodatLink will be appended.
 * @param {CodatLinkProps} props Props required to initialise CodatLink.
 * @returns A promise that resolves after CodatLink has been imported.
 */
export const initializeCodatLink = (target, props) => {
    return import(/* webpackIgnore: true */ "https://link-sdk.codat.io").then(({ CodatLink }) => {
        new CodatLink({
            target,
            props,
        });
    });
};
//# sourceMappingURL=sdk-link-types.js.map